var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 8C17.8776 8 8 17.8776 8 30C8 42.1225 17.8776 52 30 52C42.1225 52 52 42.1225 52 30C52 17.8776 42.1225 8 30 8ZM32.2449 30L24.6122 37.8571C24.1633 38.0816 23.9388 38.3061 23.4898 38.3061C23.0408 38.3061 22.5918 38.0816 22.3673 37.8571C21.6939 37.1837 21.6939 36.0612 22.3673 35.3878L28.6531 29.102V18.7755C28.6531 17.8776 29.3265 16.9796 30.449 16.9796C31.5714 16.9796 32.2449 17.6531 32.2449 18.7755V30Z",
    fill: "#030D45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.cae2191a5c26e1ed76f3b1be38f7fe5f.svg";
export { ForwardRef as ReactComponent };